import http from 'plugins/axios';

export default {
  getQrCodeInfo() {
    return http.get({
      url: '/la/admin/platform/qrcode/list',
      dataType: 'form'
    });
  },
  updateQrCodeInfo(data) {
    return http.post({
      url: '/la/admin/platform/qrcode/update',
      data,
      dataType: 'form'
    });
  }
};
